import { VALID_ITEM_TYPENAMES } from './constants.tsx';
import type { ItemTypename } from './types.tsx';

export const isFavoritableItemTypename = (typename: string): typename is ItemTypename =>
	VALID_ITEM_TYPENAMES.some((itemTypename) => itemTypename === typename);
